import Vue from 'vue';
import VueRouter from 'vue-router';
import NavMenu from '@/pages/NavMenu.vue';

Vue.use(VueRouter); // 注册vue-router

const router = new VueRouter({
    mode: "history",
    //base: '/Page/',
    routes: [
        {
            path: "/",
            name: "首页",
            component: NavMenu,
            meta: { hidden: false }
        },
        {
            path: "/login",
            name: "登录",
            component: () => import("@/pages/Login.vue"),
            meta: { hidden: true }
        },
        {
            path: "/register",
            name: "注册",
            component: () => import("@/pages/Register.vue"),
            meta: { hidden: true }
        },
        {
            path: "/reset",
            name: "忘记密码",
            component: () => import("@/pages/Reset.vue"),
            meta: { hidden: true }
        },
        {
            path: "/404",
            name: "404",
            component: () => import("@/pages/NotFound.vue"),
            meta: { hidden: true }
        },
        {
            path: '/my',
            component: NavMenu,
            name: '个人信息',
            meta: { icon: "el-icon-s-custom" },
            children: [
                {
                    path: "/my/info",
                    name: "修改昵称",
                    component: () => import("@/pages/My/My.vue"),
                    meta: { icon: "el-icon-mobile-phone" }
                },
                {
                    path: "/my/duty",
                    name: "修改职务",
                    component: () => import("@/pages/My/Duty.vue"),
                    meta: { icon: "el-icon-bank-card", roles: ["用户"] }
                },
                {
                    path: "/my/transfer",
                    name: "修改单位",
                    component: () => import("@/pages/My/Transfer.vue"),
                    meta: { icon: "el-icon-office-building", roles: ["用户"] }
                },
                {
                    path: "/my/password",
                    name: "修改密码",
                    component: () => import("@/pages/My/Password.vue"),
                    meta: { icon: "el-icon-key" }
                }
            ]
        },
        {
            path: '/manage',
            component: NavMenu,
            name: '基础信息',
            meta: { icon: "el-icon-s-tools", roles: ["系统管理员", "总队管理员", "支队管理员"] },
            children: [
                {
                    path: '/member/unit',
                    component: () => import("@/pages/Manage/Unit.vue"),
                    name: '单位管理',
                    meta: { icon: "el-icon-office-building" }
                },
                {
                    path: '/member/user',
                    component: () => import("@/pages/Manage/User.vue"),
                    name: '用户管理',
                    meta: { icon: "el-icon-user-solid" }
                },
                {
                    path: '/member/audit',
                    component: () => import("@/pages/Manage/Audit.vue"),
                    name: '注册审核',
                    meta: { icon: "el-icon-finished" }
                },
            ]
        },
        {
            path: '/training',
            component: NavMenu,
            name: '练兵管理',
            meta: { icon: "el-icon-s-flag", roles: ["系统管理员", "总队管理员", "支队管理员"] },
            children: [
                {
                    path: '/training/category',
                    component: () => import("@/pages/TrainingManage/Category.vue"),
                    name: '栏目管理',
                    meta: { icon: "el-icon-document-copy" }
                },
                {
                    path: '/training/article',
                    component: () => import("@/pages/TrainingManage/Article.vue"),
                    name: '业务资料管理',
                    props: (route) => ({
                        categoryId: route.query.categoryId
                    }),
                    meta: { icon: "el-icon-document" }
                },
                {
                    path: '/training/file',
                    component: () => import("@/pages/TrainingManage/File.vue"),
                    name: '附件管理',
                    props: (route) => ({
                        articleId: route.query.articleId
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/training/plan',
                    component: () => import("@/pages/TrainingManage/Plan.vue"),
                    name: '训练计划管理',
                    meta: { icon: "el-icon-date", hidden: true, goBack: true }
                },
            ]
        },
        {
            path: '/exam',
            component: NavMenu,
            name: '考试管理',
            meta: { icon: "el-icon-monitor", roles: ["系统管理员", "总队管理员", "支队管理员"] },
            children: [
                {
                    path: '/exam/library',
                    component: () => import("@/pages/ExamManage/Library.vue"),
                    name: '题库管理',
                    meta: { icon: "el-icon-coin" }
                },
                {
                    path: '/exam/chapter',
                    component: () => import("@/pages/ExamManage/Chapter.vue"),
                    name: '章节管理',
                    props: (route) => ({
                        libraryId: route.query.libraryId
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/exam/browse',
                    component: () => import("@/pages/ExamManage/Browse.vue"),
                    name: '试题浏览',
                    props: (route) => ({
                        libraryId: route.query.libraryId,
                        chapterId: route.query.chapterId
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/exam/formal',
                    component: () => import("@/pages/ExamManage/Formal.vue"),
                    name: '正式考试管理',
                    meta: { icon: "el-icon-timer" }
                },
                {
                    path: '/exam/record',
                    component: () => import("@/pages/ExamManage/Record.vue"),
                    name: '成绩管理',
                    props: (route) => ({
                        formalId: route.query.formalId,
                        unitId: route.query.unitId
                    }),
                    meta: { hidden: true, goBack: true }
                },
            ]
        },
        {
            path: '/study',
            component: NavMenu,
            name: '业务学习',
            meta: { icon: "el-icon-s-flag", roles: ["系统管理员", "用户"] },
            children: [
                {
                    path: '/study/article',
                    component: () => import("@/pages/Study/Article.vue"),
                    name: '业务资料',
                    meta: { icon: "el-icon-document" }
                },
                {
                    path: '/study/content',
                    component: () => import("@/pages/Study/Content.vue"),
                    name: '资料详情',
                    props: (route) => ({
                        articleId: route.query.articleId
                    }),
                    meta: { hidden: true, goBack: true }
                },
            ]
        },
        {
            path: '/test',
            component: NavMenu,
            name: '理论学习',
            meta: { icon: "el-icon-monitor", roles: ["系统管理员", "用户"] },
            children: [
                {
                    path: '/test/library',
                    component: () => import("@/pages/Test/Library.vue"),
                    name: '学习题库',
                    meta: { icon: "el-icon-notebook-1" }
                },
                {
                    path: '/test/chapter',
                    component: () => import("@/pages/Test/Chapter.vue"),
                    name: '章节练习',
                    props: (route) => ({
                        libraryId: route.query.libraryId
                    }),
                    meta: { hidden: true, goBack: true, icon: "el-icon-notebook-2" }
                },
                {
                    path: '/test/browse',
                    component: () => import("@/pages/Test/Browse.vue"),
                    name: '题库浏览',
                    props: (route) => ({
                        libraryId: route.query.libraryId,
                        chapterId: route.query.chapterId
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/test/practice',
                    component: () => import("@/pages/Test/Practice.vue"),
                    name: '自我练习',
                    props: (route) => ({
                        libraryId: route.query.libraryId,
                        chapterId: route.query.chapterId
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/test/mock',
                    component: () => import("@/pages/Test/Mock.vue"),
                    name: '模拟考试',
                    props: (route) => ({
                        libraryId: route.query.libraryId,
                        chapterId: route.query.chapterId
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/test/formal',
                    component: () => import("@/pages/Test/Formal.vue"),
                    name: '正式考试',
                    meta: { icon: "el-icon-timer" }
                },
                {
                    path: '/test/exam',
                    component: () => import("@/pages/Test/Exam.vue"),
                    name: '考场',
                    props: (route) => ({
                        formalId: route.query.formalId,
                    }),
                    meta: { hidden: true, goBack: true }
                },
                {
                    path: '/test/record',
                    component: () => import("@/pages/Test/MyRecord.vue"),
                    name: '成绩查询',
                    meta: { icon: "el-icon-timer" }
                },
            ]
        }
    ]
});

export default router;
